import { ref, getDownloadURL } from "firebase/storage";
import { FIREBASE_STORAGE } from '../firebase.config';

export const getW2Url = async (storagePath) => {
    try {
        // Get storage reference
        const storageRef = ref(FIREBASE_STORAGE, storagePath);
        
        // Get download URL with custom token settings
        const url = await getDownloadURL(storageRef);
        
        // Extract the base URL and token parts
        const [baseUrl, token] = url.split('?');
        
        // Add a longer expiration time (7 days from now)
        const newExpiry = Math.floor(Date.now() / 1000) + (7 * 24 * 60 * 60); // 7 days in seconds
        const newToken = token.replace(/Expires=\d+/, `Expires=${newExpiry}`);
        
        return `${baseUrl}?${newToken}`;
    } catch (error) {
        console.error('Error getting W2 URL:', error);
        throw error;
    }
};